module.exports = __webpack_public_path__ + "static/media/DSV2D_tdoa.634e05fa.jpg";